function Cart(){
    return <div>
        <h1>HELLO CART</h1>
    </div>
}
export default Cart